import { ComponentPropsWithoutRef, FC } from 'react';

type RefreshIconProps = ComponentPropsWithoutRef<'svg'>;

export const RefreshIcon: FC<RefreshIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M7.99997 15.54C7.10894 15.54 6.27375 15.3712 5.49441 15.0335C4.71505 14.6959 4.03465 14.2363 3.45322 13.6549C2.87179 13.0735 2.41225 12.3931 2.07459 11.6138C1.73694 10.8344 1.56812 9.9992 1.56812 9.10817H2.56728C2.56728 10.5996 3.09987 11.8779 4.16503 12.9431C5.2302 14.0083 6.50851 14.5409 7.99997 14.5409C9.49143 14.5409 10.7697 14.01 11.8349 12.9483C12.9001 11.8866 13.4327 10.6087 13.4327 9.11458C13.4327 7.62313 12.9001 6.34655 11.8349 5.28485C10.7697 4.22316 9.48872 3.69231 7.99184 3.69231H7.76199L8.85653 4.78686L8.13299 5.46071L5.8566 3.17629L8.14903 0.891876L8.87255 1.58256L7.74116 2.69315H7.99997C8.891 2.69315 9.72619 2.86197 10.5055 3.19963C11.2849 3.53728 11.9653 3.99575 12.5467 4.57504C13.1282 5.15433 13.5877 5.83366 13.9253 6.61302C14.263 7.39238 14.4318 8.22624 14.4318 9.11458C14.4318 10.0013 14.263 10.8355 13.9253 11.617C13.5877 12.3984 13.1282 13.0788 12.5467 13.6581C11.9653 14.2374 11.2849 14.6959 10.5055 15.0335C9.72619 15.3712 8.891 15.54 7.99997 15.54Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
